import React, { useState } from "react";

import { BlockStandard } from "components/admin/BlockStandard";
import { Button, Grid, TextField, Typography } from "@mui/material";
import { DeleteCTA } from "components/MUIExtensions/DeleteCTA";
import { EditOutlined, WarningAmber } from "@mui/icons-material";

export const InstallationDetail = ({
  onChange,
  onDelete,
  installationData,
}: InstallationDetailProps) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const handleClockNameChange = ({ target }) => {
    const updatedInstallation = {
      ...installationData,
      clockName: target.value,
    };
    onChange(updatedInstallation);
  };

  const handleInstallationCodeChange = ({ target }) => {
    const updatedInstallation = {
      ...installationData,
      installationCode: target.value,
    };
    onChange(updatedInstallation);
  };

  return (
    <BlockStandard>
      <TextField
        fullWidth
        label="Nome do relógio"
        value={installationData.clockName || ""}
        onChange={handleClockNameChange}
        placeholder="Ex: Relógio da Cantina"
        disabled={!isEditing}
      />

      <TextField
        fullWidth
        label="Código da Instalação"
        value={installationData.installationCode || ""}
        onChange={handleInstallationCodeChange}
        placeholder="Ex: 25000123"
        disabled={!isEditing}
      />

      <Grid item container alignItems="center">
        <WarningAmber color="warning" sx={{ mr: 2 }} />
        <Typography>Estamos validando suas credenciais de acesso</Typography>
      </Grid>

      <Grid item container justifyContent="space-around" alignItems="center">
        <Button onClick={() => setIsEditing((isEditing) => !isEditing)}>
          <EditOutlined sx={{ mr: 2 }} /> Editar
        </Button>
        <DeleteCTA onDeleteConfirmed={onDelete} />
      </Grid>
    </BlockStandard>
  );
};

export type InstallationDetailProps = {
  onChange: (updatedItem: InstallationDetailItem) => void;
  onDelete: () => void;
  installationData: InstallationDetailItem;
};

export type InstallationDetailItem = {
  id: string;
  clockName: string;
  installationCode: string;
  isCredentialValid: boolean;
};

export const emptyInstallationDetail: InstallationDetailItem = {
  id: "",
  clockName: "",
  installationCode: "",
  isCredentialValid: false,
};
